import styled from 'styled-components';

export default styled.div`
  position: absolute;
  color: var(--text-color);
  font-size: 13px;
  font-weight: 500;
  transform: translate(60px, 0);
`;
